import { SchemaDeSerBuilder, type SchemaDeSer } from "./deser"

export class CorporateEvent {
  occurredDate: Date | null = null
  amount = 0
}

export const CORPORATE_EVENT_DESER: SchemaDeSer<CorporateEvent> =
  new SchemaDeSerBuilder(CorporateEvent)
    .ofDate("occurredDate")
    .ofFloat("amount")
    .toDeSer()
